module.exports = __webpack_public_path__ + "static/media/form-bg.5c245810.jpg";